const { same } = require('../utils');

exports.computeScaleXFromCanvasStateItems = canvasStateItems => same(canvasStateItems, 'scaleX');
